// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import {
//   BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
//   ResponsiveContainer, PieChart, Pie, Cell, AreaChart, Area
// } from 'recharts';
// import {
//   Briefcase, FileText, TrendingUp, Award, RefreshCw,
//   Check, X, Clock, Bell, Search, Plus, Download,
//   Users, Calendar, ChevronRight, ArrowUpRight, ArrowDownRight,
//   Activity, Layers ,Sunrise, Sun, Sunset, Moon
// } from 'lucide-react';
// import { COMPANY_API_END_POINT } from '@/utils/constant';
// import axios from 'axios';
// import Navbar from './Navbar';
// import ApplicationsContent from '../admin/ApplicationsContent';

// /* ─── Design tokens pulled from your existing app UI ─────────────────────── */
// const APP = {
//   bg:          '#f1f5f9',   // page background — light slate
//   card:        '#ffffff',
//   border:      '#e2e8f0',
//   borderLight: '#f1f5f9',

//   primary:     '#6366f1',   // indigo-500 — your chart line / active tab colour
//   primaryDark: '#4f46e5',   // indigo-600 — hover / button
//   primaryBg:   '#eef2ff',   // indigo-50  — icon pill bg

//   purple:      '#7c3aed',
//   purpleBg:    '#ede9fe',

//   green:       '#10b981',
//   greenBg:     '#d1fae5',

//   amber:       '#f59e0b',
//   amberBg:     '#fef3c7',

//   red:         '#ef4444',
//   redBg:       '#fee2e2',

//   sky:         '#0ea5e9',
//   skyBg:       '#e0f2fe',

//   pink:        '#ec4899',
//   pinkBg:      '#fce7f3',

//   text:        '#0f172a',   // slate-900
//   textMd:      '#334155',   // slate-700
//   textSm:      '#64748b',   // slate-500
//   textXs:      '#012760',   // slate-400

//   // spinner matches your existing border-indigo-600 loader
//   spinnerBorder: '#6366f1',
// };

// const STATUS_COLORS = {
//   pending:  APP.amber,
//   accepted: APP.green,
//   rejected: APP.red,
// };

// /* ─── Tiny reusable pieces ────────────────────────────────────────────────── */
// const StatusBadge = ({ status }) => {
//   const key = status?.toLowerCase();
//   const map = {
//     pending:  { bg: APP.amberBg, color: '#92400e', Icon: Clock  },
//     accepted: { bg: APP.greenBg, color: '#065f46', Icon: Check  },
//     rejected: { bg: APP.redBg,   color: '#991b1b', Icon: X      },
//   };
//   const { bg, color, Icon } = map[key] || { bg: '#f1f5f9', color: APP.textSm, Icon: null };
//   return (
//     <span style={{ backgroundColor: bg, color, border: `1px solid ${bg}` }}
//       className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium">
//       {Icon && <Icon size={10} />}
//       {status?.charAt(0).toUpperCase() + status?.slice(1)}
//     </span>
//   );
// };

// const IconPill = ({ icon: Icon, bg, color }) => (
//   <div style={{ backgroundColor: bg }}
//     className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0">
//     <Icon size={18} style={{ color }} />
//   </div>
// );

// /* ─── Loader — exact style from your app ─────────────────────────────────── */
// const FullPageLoader = () => (
//   <div style={{ backgroundColor: APP.bg }}
//     className="flex items-center justify-center min-h-screen">
//     <div className="text-center">
//       <div style={{ borderColor: `${APP.spinnerBorder} transparent transparent transparent` }}
//         className="w-12 h-12 rounded-full border-4 animate-spin mx-auto" />
//       <p style={{ color: APP.textSm }} className="mt-4 text-sm">Loading dashboard data...</p>
//     </div>
//   </div>
// );

// const FullPageError = ({ error, onRetry }) => (
//   <div style={{ backgroundColor: APP.bg }}
//     className="flex items-center justify-center min-h-screen">
//     <div style={{ backgroundColor: APP.card, border: `1px solid ${APP.border}` }}
//       className="text-center p-8 rounded-2xl shadow-sm max-w-sm">
//       <div style={{ backgroundColor: APP.redBg }}
//         className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4">
//         <X size={20} style={{ color: APP.red }} />
//       </div>
//       <h3 style={{ color: APP.text }} className="text-base font-semibold mb-1">Failed to load dashboard</h3>
//       <p style={{ color: APP.textSm }} className="text-sm mb-5">{error}</p>
//       <button onClick={onRetry}
//         style={{ backgroundColor: APP.primary }}
//         className="inline-flex items-center gap-2 px-4 py-2 text-white text-sm rounded-lg hover:opacity-90 transition-opacity">
//         <RefreshCw size={14} /> Try Again
//       </button>
//     </div>
//   </div>
// );

// /* ─── Main component ──────────────────────────────────────────────────────── */
// const RecruiterDashboard = () => {
//   const { user } = useSelector((store) => store.auth);
//   const [dashboardData, setDashboardData] = useState(null);
//   const [loading, setLoading]             = useState(true);
//   const [error, setError]                 = useState(null);
//   const [timeFilter, setTimeFilter]       = useState('14d');
//   const [activeNav, setActiveNav]         = useState('overview');

// const getGreetingIcon = () => {
//   const hour = new Date().getHours();

//   if (hour >= 5 && hour < 12) {
//     return <Sunrise size={28} className="text-orange-400" />;
//   } else if (hour >= 12 && hour < 17) {
//     return <Sun size={28} className="text-yellow-400" />;
//   } else if (hour >= 17 && hour < 21) {
//     return <Sunset size={28} className="text-orange-500" />;
//   } else {
//     return <Moon size={26} className="text-slate-700" />;
//   }
// };

//   const fetchDashboardData = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${COMPANY_API_END_POINT}/dashboard`, {
//         withCredentials: true,
//       });
//       if (response.data.status) {
//         setDashboardData(response.data.data);
//         setError(null);
//       } else {
//         setError(response.data.message || 'Failed to fetch dashboard data');
//       }
//     } catch (err) {
//       setError('Error connecting to server');
//       console.error('Dashboard fetch error:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchDashboardData();
//     const interval = setInterval(fetchDashboardData, 5 * 60 * 1000);
//     return () => clearInterval(interval);
//   }, []);

//   if (loading && !dashboardData) return <><Navbar /><FullPageLoader /></>;
//   if (error   && !dashboardData) return <><Navbar /><FullPageError error={error} onRetry={fetchDashboardData} /></>;

//   /* derived values */
//   const totalJobs  = dashboardData?.totalJobs        || 0;
//   const totalApps  = dashboardData?.totalApplications || 0;
//   const pending    = dashboardData?.jobsByStatus?.find(s => s.status === 'pending' )?.count || 0;
//   const accepted   = dashboardData?.jobsByStatus?.find(s => s.status === 'accepted')?.count || 0;
//   const rejected   = dashboardData?.jobsByStatus?.find(s => s.status === 'rejected')?.count || 0;
//   const appRate    = totalJobs ? (totalApps / totalJobs).toFixed(1) : '0';
//   const acceptRate = totalApps ? ((accepted / totalApps) * 100).toFixed(1) : '0';
//   const rejRate    = totalApps ? ((rejected / totalApps) * 100).toFixed(1) : '0';

//   const getHour = () => {
//     const h = new Date().getHours();
//     return h < 12 ? 'morning' : h < 17 ? 'afternoon' : 'evening';
//   };
//   const today = new Date().toLocaleDateString('en-US', {
//     weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
//   });

//   /* nav */
//   const NAV_MAIN = [
//     { key: 'overview',      label: 'Overview',      icon: Layers,     badge: null      },
//     { key: 'pipeline',      label: 'Pipeline',      icon: Activity,   badge: pending   },
//     { key: 'applications',  label: 'Applications',  icon: FileText,   badge: totalApps },
//     { key: 'jobs',          label: 'Jobs',           icon: Briefcase,  badge: null      },
//     { key: 'trends',        label: 'Trends',         icon: TrendingUp, badge: null      },
//   ];
//   const NAV_MANAGE = [
//     { key: 'candidates',  label: 'Candidates',  icon: Users    },
//     { key: 'interviews',  label: 'Interviews',  icon: Calendar },
//   ];

//   /* KPI card definitions */
//   const KPI_CARDS = [
//     { label: 'Active jobs',          value: totalJobs, sub: `${totalJobs} total posted`,  icon: Briefcase,  bg: APP.primaryBg, color: APP.primary,  trend: null },
//     { label: 'Total applications',   value: totalApps, sub: `${appRate} per job`,         icon: FileText,   bg: APP.purpleBg,  color: APP.purple,   trend: { dir: 'up',   label: `${appRate} per job`  } },
//     { label: 'Offers accepted',      value: accepted,  sub: `${acceptRate}% accept rate`, icon: Award,      bg: APP.greenBg,   color: APP.green,    trend: { dir: 'up',   label: `${acceptRate}% accept rate` } },
//     { label: 'Pending review',       value: pending,   sub: 'Awaiting decision',          icon: Clock,      bg: APP.amberBg,   color: APP.amber,    trend: null },
//     { label: 'Interviews this week', value: '—',       sub: 'See calendar',               icon: Calendar,   bg: APP.skyBg,     color: APP.sky,      trend: null },
//     { label: 'Avg. days to hire',    value: '—',       sub: 'Time to fill',               icon: TrendingUp, bg: APP.pinkBg,    color: APP.pink,     trend: null },
//   ];

//   const tooltipStyle = {
//     borderRadius: 10, border: 'none',
//     boxShadow: '0 4px 20px rgba(0,0,0,0.10)', fontSize: 12,
//     backgroundColor: '#fff', color: APP.textMd,
//   };

//   return (
//     <>
//       <Navbar />
//       <div style={{ backgroundColor: APP.bg, fontFamily: 'inherit' }} className="flex min-h-screen pt-20">

//         {/* ── Sidebar ──────────────────────────────────────────────────────── */}
//         <aside style={{ backgroundColor: APP.card, borderRight: `1px solid ${APP.border}` }}
//           className="w-56 flex-shrink-0 flex-col py-6 px-3 hidden lg:flex">

//           {/* Logo */}
//           <div className="mb-6 px-2 flex items-center gap-2">
//             <div style={{ backgroundColor: APP.primary }} className="w-8 h-8 rounded-lg flex items-center justify-center">
//               <Briefcase size={15} className="text-white" />
//             </div>
//             <div>
//               <p style={{ color: APP.text }} className="text-sm font-bold leading-none">Hirees</p>
//               <p style={{ color: APP.textXs }} className="text-[10px] mt-0.5">Recruiter portal</p>
//             </div>
//           </div>

//           {/* Main nav */}
//           <p style={{ color: APP.textXs }} className="text-[10px] font-semibold uppercase tracking-widest px-2 mb-2">Main</p>
//          <nav className="space-y-2 mb-5">
//   {NAV_MAIN.map(({ key, label, icon: Icon, badge }) => {
//     const active = activeNav === key;

//     return (
//       <button
//         key={key}
//         onClick={() => setActiveNav(key)}
//         className={`w-full flex items-center justify-between px-4 py-3 rounded-2xl text-sm transition-all duration-200
//         ${
//           active
//             ? "border border-[#012760] bg-[#eef4ff] text-[#012760] font-semibold shadow-sm"
//             : "text-slate-700 hover:bg-slate-100"
//         }`}
//       >
//         <span className="flex items-center gap-3">
//           <Icon size={17} />
//           {label}
//         </span>

//         {badge ? (
//           <span
//             className={`text-[10px] font-semibold px-2 py-0.5 rounded-full
//             ${
//               active
//                 ? "bg-[#012760] text-white"
//                 : "bg-slate-200 text-slate-600"
//             }`}
//           >
//             {badge}
//           </span>
//         ) : null}
//       </button>
//     );
//   })}
// </nav>

//           {/* Manage nav */}
//           <p style={{ color: APP.textXs }} className="text-[10px] font-semibold uppercase tracking-widest px-2 mb-2">Manage</p>
//           <nav className="space-y-0.5">
//             {NAV_MANAGE.map(({ key, label, icon: Icon }) => (
//               <button key={key} onClick={() => setActiveNav(key)}
//                 style={{ color: APP.textMd }}
//                 className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm hover:bg-slate-50 transition-colors">
//                 <Icon size={15} />{label}
//               </button>
//             ))}
//           </nav>
//         </aside>

//         {/* ── Main area ────────────────────────────────────────────────────── */}
//         <main className="flex-1 min-w-0 overflow-auto">

//           {/* Top bar search and notifications */}
//           {/* <div style={{ backgroundColor: APP.bg, borderBottom: `1px solid ${APP.border}` }}
//             className="sticky top-0 z-10 px-6 py-3 flex items-center gap-3">
//             <div className="relative flex-1 max-w-xs">
//               <Search size={14} style={{ color: APP.textXs }} className="absolute left-3 top-1/2 -translate-y-1/2" />
//               <input type="text" placeholder="Search candidates, jobs…"
//                 style={{ backgroundColor: APP.card, borderColor: APP.border, color: APP.text }}
//                 className="w-full pl-8 pr-4 py-2 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-transparent" />
//             </div>
//             <div className="ml-auto flex items-center gap-2">
//               <button style={{ backgroundColor: APP.card, borderColor: APP.border, color: APP.textSm }}
//                 className="relative p-2 border rounded-lg hover:bg-slate-50 transition-colors">
//                 <Bell size={16} />
//                 <span style={{ backgroundColor: APP.red }} className="absolute top-1 right-1 w-2 h-2 rounded-full" />
//               </button>
//               <div style={{ backgroundColor: APP.primary }} className="w-8 h-8 rounded-full text-white text-xs font-bold flex items-center justify-center">R</div>
//             </div>
//           </div> */}

//           <div className="p-6 max-w-6xl mx-auto">

//             {/* Page header */}
//             <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
//              <div>
//   <div className="flex items-center gap-3">
//     <h1 className="text-2xl md:text-3xl font-bold leading-tight">
//       <span className="text-black">
//         Good {getHour()},
//       </span>{" "}
//       <span className="text-blue-500">
//         {user?.fullname?.split(" ")[0] || "Recruiter"}
//       </span>
//     </h1>

//     {getGreetingIcon()}
//   </div>

//   <p
//     style={{ color: APP.textSm }}
//     className="text-sm mt-1"
//   >
//     {today} · {totalJobs} open positions
//   </p>
// </div>
//               <div className="flex gap-2 flex-wrap">
//                 <button style={{ backgroundColor: APP.card, borderColor: APP.border, color: APP.textMd }}
//                   className="inline-flex items-center gap-1.5 px-3 py-2 text-sm border rounded-lg hover:bg-slate-50 transition-colors">
//                   <Download size={14} /> Export
//                 </button>
//                 <button style={{ backgroundColor: APP.primary }}
//                   className="inline-flex items-center gap-2 px-5 py-3 bg-gradient-to-r from-red-500 to-orange-500 hover:from-red-600 hover:to-orange-600 text-white text-sm font-bold rounded-xl shadow-lg shadow-orange-200 hover:shadow-orange-300 hover:-translate-y-0.5 active:translate-y-0 transition-all w-full sm:w-auto justify-center">                  <Plus size={14} /> Post a job
//                 </button>
//                 <button onClick={fetchDashboardData} disabled={loading}
//                   style={{ backgroundColor: APP.card, borderColor: APP.border, color: APP.textSm }}
//                   className={`p-2 border rounded-lg hover:bg-slate-50 transition-colors ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}>
//                   <RefreshCw size={15} className={loading ? 'animate-spin' : ''} />
//                 </button>
//               </div>
//             </div>

//             {/* KPI cards */}
//             <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-5">
//               {KPI_CARDS.map(({ label, value, sub, icon: Icon, bg, color, trend }) => (
//                 <div key={label}
//                   style={{ backgroundColor: APP.card, border: `1px solid ${APP.border}` }}
//                   className="rounded-2xl p-4 flex flex-col gap-3 hover:shadow-sm transition-shadow">
//                   <IconPill icon={Icon} bg={bg} color={color} />
//                   <div>
//                     <p style={{ color: APP.text }} className="text-2xl font-bold leading-none">{value}</p>
//                     <p style={{ color: APP.textSm }} className="text-xs mt-1">{label}</p>
//                   </div>
//                   {trend ? (
//                     <p style={{ color: trend.dir === 'up' ? APP.green : APP.red }}
//                       className="text-xs font-medium flex items-center gap-1">
//                       {trend.dir === 'up' ? <ArrowUpRight size={12} /> : <ArrowDownRight size={12} />}
//                       {trend.label}
//                     </p>
//                   ) : (
//                     <p style={{ color: APP.textXs }} className="text-xs">{sub}</p>
//                   )}
//                 </div>
//               ))}
//             </div>

//             {/* Middle row */}
//             {activeNav !== 'applications' && (
//             <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">

//               {/* Application trend */}
//               <div style={{ backgroundColor: APP.card, border: `1px solid ${APP.border}` }}
//                 className="lg:col-span-2 rounded-2xl p-5">
//                 <div className="flex items-center justify-between mb-1">
//                   <div>
//                     <h3 style={{ color: APP.text }} className="text-sm font-semibold">Application trend</h3>
//                     <p style={{ color: APP.textXs }} className="text-xs">Daily submissions — last {timeFilter === '7d' ? '7' : '14'} days</p>
//                   </div>
//                   <div style={{ border: `1px solid ${APP.border}` }} className="flex rounded-lg overflow-hidden">
//                     {['7d','14d'].map(t => (
//                       <button key={t} onClick={() => setTimeFilter(t)}
//                         style={timeFilter === t
//                           ? { backgroundColor: APP.primary, color: '#fff' }
//                           : { backgroundColor: APP.card, color: APP.textMd }}
//                         className="px-3 py-1.5 text-xs font-medium hover:opacity-90 transition-opacity">
//                         {t.toUpperCase()}
//                       </button>
//                     ))}
//                   </div>
//                 </div>
//                 <div className="h-52 mt-4">
//                   <ResponsiveContainer width="100%" height="100%">
//                     <AreaChart data={dashboardData?.applicationTrend || []} margin={{ top: 4, right: 4, bottom: 0, left: -20 }}>
//                       <defs>
//                         <linearGradient id="areaGrad" x1="0" y1="0" x2="0" y2="1">
//                           <stop offset="5%"  stopColor={APP.primary} stopOpacity={0.15} />
//                           <stop offset="95%" stopColor={APP.primary} stopOpacity={0}    />
//                         </linearGradient>
//                       </defs>
//                       <CartesianGrid strokeDasharray="3 3" stroke={APP.borderLight} vertical={false} />
//                       <XAxis dataKey="date"
//                         tickFormatter={v => new Date(v).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
//                         stroke={APP.border} tick={{ fontSize: 11, fill: APP.textXs }}
//                         axisLine={false} tickLine={false} />
//                       <YAxis stroke={APP.border} tick={{ fontSize: 11, fill: APP.textXs }} axisLine={false} tickLine={false} />
//                       <Tooltip formatter={v => [`${v} applications`, 'Applications']}
//                         labelFormatter={l => new Date(l).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
//                         contentStyle={tooltipStyle} />
//                       <Area type="monotone" dataKey="count" stroke={APP.primary} strokeWidth={2.5}
//                         fill="url(#areaGrad)" dot={false} activeDot={{ r: 5, fill: APP.primary }} />
//                     </AreaChart>
//                   </ResponsiveContainer>
//                 </div>
//               </div>

//               {/* Pipeline health */}
//               <div style={{ backgroundColor: APP.card, border: `1px solid ${APP.border}` }}
//                 className="rounded-2xl p-5">
//                 <h3 style={{ color: APP.text }} className="text-sm font-semibold mb-1">Pipeline health</h3>
//                 <p style={{ color: APP.textXs }} className="text-xs mb-3">Application status breakdown</p>
//                 <div className="h-44">
//                   <ResponsiveContainer width="100%" height="100%">
//                     <PieChart>
//                       <Pie data={dashboardData?.jobsByStatus || []}
//                         cx="50%" cy="50%" innerRadius={52} outerRadius={76}
//                         paddingAngle={3} dataKey="count" strokeWidth={0}>
//                         {(dashboardData?.jobsByStatus || []).map((entry, i) => (
//                           <Cell key={i} fill={STATUS_COLORS[entry.status] || APP.border} />
//                         ))}
//                       </Pie>
//                       <Tooltip formatter={(v, _, p) => [`${v} applications`, p.payload.status]}
//                         contentStyle={tooltipStyle} />
//                     </PieChart>
//                   </ResponsiveContainer>
//                 </div>
//                 <div className="space-y-2 mt-2">
//                   {(dashboardData?.jobsByStatus || []).map(s => (
//                     <div key={s.status} className="flex items-center justify-between">
//                       <div className="flex items-center gap-2">
//                         <span className="w-2.5 h-2.5 rounded-full flex-shrink-0"
//                           style={{ backgroundColor: STATUS_COLORS[s.status] }} />
//                         <span style={{ color: APP.textMd }} className="text-xs capitalize">{s.status}</span>
//                       </div>
//                       <span style={{ color: APP.text }} className="text-xs font-semibold">{s.count}</span>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>

//                 )}

//             {/* Bottom row */}
// {activeNav === 'applications' ? (
//   <ApplicationsContent dashboardData={dashboardData} />
// ) : (
//   <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">

//     {/* Top jobs */}
//     <div style={{ backgroundColor: APP.card, border: `1px solid ${APP.border}` }}
//       className="rounded-2xl p-5">
//       <div className="flex items-center justify-between mb-4">
//         <h3 style={{ color: APP.text }} className="text-sm font-semibold">Top jobs</h3>
//         <button style={{ color: APP.primary, border: `1px solid ${APP.primaryBg}`, backgroundColor: APP.primaryBg }}
//           className="text-xs font-medium px-2.5 py-1 rounded-lg hover:opacity-90 transition-opacity">
//           View all
//         </button>
//       </div>
//       {!(dashboardData?.applicationsByJob?.length) ? (
//         <p style={{ color: APP.textXs }} className="text-sm text-center py-6">No data yet</p>
//       ) : (
//         <div className="h-52">
//           <ResponsiveContainer width="100%" height="100%">
//             <BarChart data={(dashboardData?.applicationsByJob || []).slice(0, 5)}
//               layout="vertical" margin={{ top: 0, right: 10, left: 0, bottom: 0 }}>
//               <XAxis type="number" hide />
//               <YAxis type="category" dataKey="jobTitle" width={80}
//                 tick={{ fontSize: 11, fill: APP.textSm }}
//                 tickFormatter={v => v.length > 10 ? v.slice(0, 10) + '…' : v}
//                 axisLine={false} tickLine={false} />
//               <Tooltip formatter={v => [`${v}`, 'Applications']} contentStyle={tooltipStyle} />
//               <Bar dataKey="applicationCount" fill={APP.primary} barSize={10} radius={[0, 4, 4, 0]} />
//             </BarChart>
//           </ResponsiveContainer>
//         </div>
//       )}
//     </div>

//     {/* Quick stats */}
//     <div style={{ backgroundColor: APP.card, border: `1px solid ${APP.border}` }}
//       className="rounded-2xl p-5">
//       <h3 style={{ color: APP.text }} className="text-sm font-semibold mb-4">Quick stats</h3>
//       <div className="space-y-0 divide-y" style={{ borderColor: APP.borderLight }}>
//         {[
//           { label: 'Applications / job', value: appRate          },
//           { label: 'Offer rate',         value: `${acceptRate}%` },
//           { label: 'Rejection rate',     value: `${rejRate}%`    },
//           { label: 'Total jobs posted',  value: totalJobs        },
//           { label: 'Total applications', value: totalApps        },
//           { label: 'Pending decisions',  value: pending          },
//         ].map(({ label, value }) => (
//           <div key={label} className="flex items-center justify-between py-2.5">
//             <span style={{ color: APP.textSm }} className="text-xs">{label}</span>
//             <span style={{ color: APP.text }} className="text-sm font-bold">{value}</span>
//           </div>
//         ))}
//       </div>
//     </div>

//     {/* Recent applications */}
//     <div style={{ backgroundColor: APP.card, border: `1px solid ${APP.border}` }}
//       className="rounded-2xl p-5">
//       <div className="flex items-center justify-between mb-4">
//         <h3 style={{ color: APP.text }} className="text-sm font-semibold">Recent applications</h3>
//         <button
//           onClick={() => setActiveNav('applications')}
//           style={{ color: APP.primary }}
//           className="inline-flex items-center gap-1 text-xs font-medium hover:underline">
//           View all <ChevronRight size={12} />
//         </button>
//       </div>
//       {!(dashboardData?.recentApplications?.length) ? (
//         <p style={{ color: APP.textXs }} className="text-sm text-center py-6">No applications yet</p>
//       ) : (
//         <div className="divide-y" style={{ borderColor: APP.borderLight }}>
//           {(dashboardData?.recentApplications || []).slice(0, 6).map(app => (
//             <div key={app.id}
//               className="flex items-center gap-3 py-2.5 rounded-lg cursor-pointer hover:bg-slate-50 -mx-2 px-2 transition-colors">
//               <div style={{ backgroundColor: APP.primaryBg, color: APP.primary }}
//                 className="w-9 h-9 rounded-full text-sm font-bold flex items-center justify-center flex-shrink-0">
//                 {app.candidateName?.charAt(0).toUpperCase()}
//               </div>
//               <div className="flex-1 min-w-0">
//                 <p style={{ color: APP.text }} className="text-xs font-medium truncate">{app.candidateName}</p>
//                 <p style={{ color: APP.textSm }} className="text-[11px] truncate">{app.jobTitle}</p>
//               </div>
//               <div className="flex flex-col items-end gap-1">
//                 <StatusBadge status={app.status} />
//                 <span style={{ color: APP.textXs }} className="text-[10px]">
//                   {new Date(app.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
//                 </span>
//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>

//   </div>
// )}
//           </div>
//         </main>
//       </div>
//     </>
//   );
// };

// export default RecruiterDashboard;









import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer, PieChart, Pie, Cell, AreaChart, Area
} from 'recharts';
import {
  Briefcase, FileText, TrendingUp, Award, RefreshCw,
  Check, X, Clock, Bell, Search, Plus, Download,
  Users, Calendar, ChevronRight, ArrowUpRight, ArrowDownRight,
  Activity, Layers, Sunrise, Sun, Sunset, Moon
} from 'lucide-react';
import { COMPANY_API_END_POINT } from '@/utils/constant';
import axios from 'axios';
import Navbar from './Navbar';
import DashbordApplicationTab, {
  APP, STATUS_COLORS, StatusBadge, IconPill,
} from './DashbordApplicationTab';
import { useNavigate } from 'react-router-dom';
import NotificationBell from './NotificationBell';
import { socket } from "@/socket";
/* ─── Loader — exact style from your app ─────────────────────────────────── */
const FullPageLoader = () => (
  <div style={{ backgroundColor: APP.bg }}
    className="flex items-center justify-center min-h-screen">
    <div className="text-center">
      <div style={{ borderColor: `${APP.spinnerBorder} transparent transparent transparent` }}
        className="w-12 h-12 rounded-full border-4 animate-spin mx-auto" />
      <p style={{ color: APP.textSm }} className="mt-4 text-sm">Loading dashboard data...</p>
    </div>
  </div>
);

const FullPageError = ({ error, onRetry }) => (
  <div style={{ backgroundColor: APP.bg }}
    className="flex items-center justify-center min-h-screen">
    <div style={{ backgroundColor: APP.card, border: `1px solid ${APP.border}` }}
      className="text-center p-8 rounded-2xl shadow-sm max-w-sm">
      <div style={{ backgroundColor: APP.redBg }}
        className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4">
        <X size={20} style={{ color: APP.red }} />
      </div>
      <h3 style={{ color: APP.text }} className="text-base font-semibold mb-1">Failed to load dashboard</h3>
      <p style={{ color: APP.textSm }} className="text-sm mb-5">{error}</p>
      <button onClick={onRetry}
        style={{ backgroundColor: APP.primary }}
        className="inline-flex items-center gap-2 px-4 py-2 text-white text-sm rounded-lg hover:opacity-90 transition-opacity">
        <RefreshCw size={14} /> Try Again
      </button>
    </div>
  </div>
);

/* ─── Main component ──────────────────────────────────────────────────────── */
const RecruiterDashboard = () => {
  const { user } = useSelector((store) => store.auth);
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [timeFilter, setTimeFilter] = useState('14d');
  const [activeNav, setActiveNav] = useState('overview');
  const navigate = useNavigate();


  
useEffect(() => {
  const recruiterEmail = user?.email;
  if (!recruiterEmail) return;

  const handleConnect = () => {
    socket.emit("joinRecruiter", recruiterEmail);
  };

  if (socket.connected) handleConnect();   // already connected
  socket.on("connect", handleConnect);     // fires on reconnect too

  return () => socket.off("connect", handleConnect);
}, [user]);

  const getGreetingIcon = () => {
    const hour = new Date().getHours();

    if (hour >= 5 && hour < 12) {
      return <Sunrise size={28} className="text-orange-400" />;
    } else if (hour >= 12 && hour < 17) {
      return <Sun size={28} className="text-yellow-400" />;
    } else if (hour >= 17 && hour < 21) {
      return <Sunset size={28} className="text-orange-500" />;
    } else {
      return <Moon size={26} className="text-slate-700" />;
    }
  };

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${COMPANY_API_END_POINT}/dashboard`, {
        withCredentials: true,
      });
      if (response.data.status) {
        setDashboardData(response.data.data);
        setError(null);
      } else {
        setError(response.data.message || 'Failed to fetch dashboard data');
      }
    } catch (err) {
      setError('Error connecting to server');
      console.error('Dashboard fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
    const interval = setInterval(fetchDashboardData, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  if (loading && !dashboardData) return <><Navbar /><FullPageLoader /></>;
  if (error && !dashboardData) return <><Navbar /><FullPageError error={error} onRetry={fetchDashboardData} /></>;

  /* derived values */
  const totalJobs = dashboardData?.totalJobs || 0;
  const totalApps = dashboardData?.totalApplications || 0;
  const pending = dashboardData?.jobsByStatus?.find(s => s.status === 'pending')?.count || 0;
  const accepted = dashboardData?.jobsByStatus?.find(s => s.status === 'accepted')?.count || 0;
  const rejected = dashboardData?.jobsByStatus?.find(s => s.status === 'rejected')?.count || 0;
  const appRate = totalJobs ? (totalApps / totalJobs).toFixed(1) : '0';
  const acceptRate = totalApps ? ((accepted / totalApps) * 100).toFixed(1) : '0';
  const rejRate = totalApps ? ((rejected / totalApps) * 100).toFixed(1) : '0';

  const getHour = () => {
    const h = new Date().getHours();
    return h < 12 ? 'morning' : h < 17 ? 'afternoon' : 'evening';
  };
  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
  });

  /* nav */
  const NAV_MAIN = [
    { key: 'overview', label: 'Overview', icon: Layers, badge: null },
    { key: 'pipeline', label: 'Pipeline', icon: Activity, badge: pending },
    { key: 'applications', label: 'Applications', icon: FileText, badge: totalApps },
    { key: 'jobs', label: 'Jobs', icon: Briefcase, badge: null },
    { key: 'trends', label: 'Trends', icon: TrendingUp, badge: null },
  ];
  const NAV_MANAGE = [
    { key: 'candidates', label: 'Candidates', icon: Users },
    { key: 'interviews', label: 'Interviews', icon: Calendar },
  ];

  /* KPI card definitions */
  const KPI_CARDS = [
    { label: 'Active jobs', value: totalJobs, sub: `${totalJobs} total posted`, icon: Briefcase, bg: APP.primaryBg, color: APP.primary, trend: null },
    { label: 'Total applications', value: totalApps, sub: `${appRate} per job`, icon: FileText, bg: APP.purpleBg, color: APP.purple, trend: { dir: 'up', label: `${appRate} per job` } },
    { label: 'Offers accepted', value: accepted, sub: `${acceptRate}% accept rate`, icon: Award, bg: APP.greenBg, color: APP.green, trend: { dir: 'up', label: `${acceptRate}% accept rate` } },
    { label: 'Pending review', value: pending, sub: 'Awaiting decision', icon: Clock, bg: APP.amberBg, color: APP.amber, trend: null },
    { label: 'Interviews this week', value: '—', sub: 'See calendar', icon: Calendar, bg: APP.skyBg, color: APP.sky, trend: null },
    { label: 'Avg. days to hire', value: '—', sub: 'Time to fill', icon: TrendingUp, bg: APP.pinkBg, color: APP.pink, trend: null },
  ];

  const tooltipStyle = {
    borderRadius: 10, border: 'none',
    boxShadow: '0 4px 20px rgba(0,0,0,0.10)', fontSize: 12,
    backgroundColor: '#fff', color: APP.textMd,
  };

  return (
    <>
      <Navbar />
      <div style={{ backgroundColor: APP.bg, fontFamily: 'inherit' }} className="flex min-h-screen pt-20">

        {/* ── Sidebar ──────────────────────────────────────────────────────── */}
        <aside style={{ backgroundColor: APP.card, borderRight: `1px solid ${APP.border}` }}
          className="w-56 flex-shrink-0 flex-col py-6 px-3 hidden lg:flex">

          {/* Logo */}
          <div className="mb-6 px-2 flex items-center gap-2">
            <div style={{ backgroundColor: APP.primary }} className="w-8 h-8 rounded-lg flex items-center justify-center">
              <Briefcase size={15} className="text-white" />
            </div>
            <div>
              <p style={{ color: APP.text }} className="text-sm font-bold leading-none">Hirees</p>
              <p style={{ color: APP.textXs }} className="text-[10px] mt-0.5">Recruiter portal</p>
            </div>
          </div>

          {/* Main nav */}
          <p style={{ color: APP.textXs }} className="text-[10px] font-semibold uppercase tracking-widest px-2 mb-2">Main</p>
          <nav className="space-y-2 mb-5">
            {NAV_MAIN.map(({ key, label, icon: Icon, badge }) => {
              const active = activeNav === key;

              return (
                <button
                  key={key}
                  onClick={() => setActiveNav(key)}
                  className={`w-full flex items-center justify-between px-4 py-3 rounded-2xl text-sm transition-all duration-200
        ${active
                      ? "border border-[#012760] bg-[#eef4ff] text-[#012760] font-semibold shadow-sm"
                      : "text-slate-700 hover:bg-slate-100"
                    }`}
                >
                  <span className="flex items-center gap-3">
                    <Icon size={17} />
                    {label}
                  </span>

                  {badge ? (
                    <span
                      className={`text-[10px] font-semibold px-2 py-0.5 rounded-full
            ${active
                          ? "bg-[#012760] text-white"
                          : "bg-slate-200 text-slate-600"
                        }`}
                    >
                      {badge}
                    </span>
                  ) : null}
                </button>
              );
            })}
          </nav>

          {/* Manage nav */}
          <p style={{ color: APP.textXs }} className="text-[10px] font-semibold uppercase tracking-widest px-2 mb-2">Manage</p>
          <nav className="space-y-0.5">
            {NAV_MANAGE.map(({ key, label, icon: Icon }) => (
              <button key={key} onClick={() => setActiveNav(key)}
                style={{ color: APP.textMd }}
                className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm hover:bg-slate-50 transition-colors">
                <Icon size={15} />{label}
              </button>
            ))}
          </nav>
        </aside>

        {/* ── Main area ────────────────────────────────────────────────────── */}
        <main className="flex-1 min-w-0 overflow-auto">

          <div className="p-6 max-w-6xl mx-auto">

            {/* Page header */}
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
              <div>
                <div className="flex items-center gap-3">
                  <h1 className="text-2xl md:text-3xl font-bold leading-tight">
                    <span className="text-black">
                      Good {getHour()},
                    </span>{" "}
                    <span className="text-blue-500">
                      {user?.fullname?.split(" ")[0] || "Recruiter"}
                    </span>
                  </h1>

                  {getGreetingIcon()}
                </div>

                <p
                  style={{ color: APP.textSm }}
                  className="text-sm mt-1"
                >
                  {today} · {totalJobs} open positions
                </p>
              </div>
              <div className="flex gap-2 flex-wrap">
                <button style={{ backgroundColor: APP.card, borderColor: APP.border, color: APP.textMd }}
                  className="inline-flex items-center gap-1.5 px-3 py-2 text-sm border rounded-lg hover:bg-slate-50 transition-colors">
                  <Download size={14} /> Export
                </button>
                <NotificationBell />
                <button
                  onClick={() => navigate("/admin/jobs/post")}
                  className="inline-flex items-center gap-2 px-5 py-3 bg-gradient-to-r from-red-500 to-orange-500 hover:from-red-600 hover:to-orange-600 text-white text-sm font-bold rounded-xl shadow-lg shadow-orange-200 hover:shadow-orange-300 hover:-translate-y-0.5 active:translate-y-0 transition-all w-full sm:w-auto justify-center"
                >
                  <Plus size={17} strokeWidth={2.5} />
                  Post New Job
                </button>
                <button onClick={fetchDashboardData} disabled={loading}
                  style={{ backgroundColor: APP.card, borderColor: APP.border, color: APP.textSm }}
                  className={`p-2 border rounded-lg hover:bg-slate-50 transition-colors ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}>
                  <RefreshCw size={15} className={loading ? 'animate-spin' : ''} />
                </button>
              </div>
            </div>

            {/* KPI cards */}
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-5">
              {KPI_CARDS.map(({ label, value, sub, icon: Icon, bg, color, trend }) => (
                <div key={label}
                  style={{ backgroundColor: APP.card, border: `1px solid ${APP.border}` }}
                  className="rounded-2xl p-4 flex flex-col gap-3 hover:shadow-sm transition-shadow">
                  <IconPill icon={Icon} bg={bg} color={color} />
                  <div>
                    <p style={{ color: APP.text }} className="text-2xl font-bold leading-none">{value}</p>
                    <p style={{ color: APP.textSm }} className="text-xs mt-1">{label}</p>
                  </div>
                  {trend ? (
                    <p style={{ color: trend.dir === 'up' ? APP.green : APP.red }}
                      className="text-xs font-medium flex items-center gap-1">
                      {trend.dir === 'up' ? <ArrowUpRight size={12} /> : <ArrowDownRight size={12} />}
                      {trend.label}
                    </p>
                  ) : (
                    <p style={{ color: APP.textXs }} className="text-xs">{sub}</p>
                  )}
                </div>
              ))}
            </div>

            {/* Middle row */}
            {activeNav !== 'applications' && (
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">

                {/* Application trend */}
                <div style={{ backgroundColor: APP.card, border: `1px solid ${APP.border}` }}
                  className="lg:col-span-2 rounded-2xl p-5">
                  <div className="flex items-center justify-between mb-1">
                    <div>
                      <h3 style={{ color: APP.text }} className="text-sm font-semibold">Application trend</h3>
                      <p style={{ color: APP.textXs }} className="text-xs">Daily submissions — last {timeFilter === '7d' ? '7' : '14'} days</p>
                    </div>
                    <div style={{ border: `1px solid ${APP.border}` }} className="flex rounded-lg overflow-hidden">
                      {['7d', '14d'].map(t => (
                        <button key={t} onClick={() => setTimeFilter(t)}
                          style={timeFilter === t
                            ? { backgroundColor: APP.primary, color: '#fff' }
                            : { backgroundColor: APP.card, color: APP.textMd }}
                          className="px-3 py-1.5 text-xs font-medium hover:opacity-90 transition-opacity">
                          {t.toUpperCase()}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="h-52 mt-4">
                    <ResponsiveContainer width="100%" height="100%">
                      <AreaChart data={dashboardData?.applicationTrend || []} margin={{ top: 4, right: 4, bottom: 0, left: -20 }}>
                        <defs>
                          <linearGradient id="areaGrad" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor={APP.primary} stopOpacity={0.15} />
                            <stop offset="95%" stopColor={APP.primary} stopOpacity={0} />
                          </linearGradient>
                        </defs>
                        <CartesianGrid strokeDasharray="3 3" stroke={APP.borderLight} vertical={false} />
                        <XAxis dataKey="date"
                          tickFormatter={v => new Date(v).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                          stroke={APP.border} tick={{ fontSize: 11, fill: APP.textXs }}
                          axisLine={false} tickLine={false} />
                        <YAxis stroke={APP.border} tick={{ fontSize: 11, fill: APP.textXs }} axisLine={false} tickLine={false} />
                        <Tooltip formatter={v => [`${v} applications`, 'Applications']}
                          labelFormatter={l => new Date(l).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                          contentStyle={tooltipStyle} />
                        <Area type="monotone" dataKey="count" stroke={APP.primary} strokeWidth={2.5}
                          fill="url(#areaGrad)" dot={false} activeDot={{ r: 5, fill: APP.primary }} />
                      </AreaChart>
                    </ResponsiveContainer>
                  </div>
                </div>

                {/* Pipeline health */}
                <div style={{ backgroundColor: APP.card, border: `1px solid ${APP.border}` }}
                  className="rounded-2xl p-5">
                  <h3 style={{ color: APP.text }} className="text-sm font-semibold mb-1">Pipeline health</h3>
                  <p style={{ color: APP.textXs }} className="text-xs mb-3">Application status breakdown</p>
                  <div className="h-44">
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart>
                        <Pie data={dashboardData?.jobsByStatus || []}
                          cx="50%" cy="50%" innerRadius={52} outerRadius={76}
                          paddingAngle={3} dataKey="count" strokeWidth={0}>
                          {(dashboardData?.jobsByStatus || []).map((entry, i) => (
                            <Cell key={i} fill={STATUS_COLORS[entry.status] || APP.border} />
                          ))}
                        </Pie>
                        <Tooltip formatter={(v, _, p) => [`${v} applications`, p.payload.status]}
                          contentStyle={tooltipStyle} />
                      </PieChart>
                    </ResponsiveContainer>
                  </div>
                  <div className="space-y-2 mt-2">
                    {(dashboardData?.jobsByStatus || []).map(s => (
                      <div key={s.status} className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <span className="w-2.5 h-2.5 rounded-full flex-shrink-0"
                            style={{ backgroundColor: STATUS_COLORS[s.status] }} />
                          <span style={{ color: APP.textMd }} className="text-xs capitalize">{s.status}</span>
                        </div>
                        <span style={{ color: APP.text }} className="text-xs font-semibold">{s.count}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

            )}

            {/* Bottom row */}
            {activeNav === 'applications' ? (
              <DashbordApplicationTab dashboardData={dashboardData} />
            ) : (
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">

                {/* Top jobs */}
                <div style={{ backgroundColor: APP.card, border: `1px solid ${APP.border}` }}
                  className="rounded-2xl p-5">
                  <div className="flex items-center justify-between mb-4">
                    <h3 style={{ color: APP.text }} className="text-sm font-semibold">Top jobs</h3>
                    <button style={{ color: APP.primary, border: `1px solid ${APP.primaryBg}`, backgroundColor: APP.primaryBg }}
                      className="text-xs font-medium px-2.5 py-1 rounded-lg hover:opacity-90 transition-opacity">
                      View all
                    </button>
                  </div>
                  {!(dashboardData?.applicationsByJob?.length) ? (
                    <p style={{ color: APP.textXs }} className="text-sm text-center py-6">No data yet</p>
                  ) : (
                    <div className="h-52">
                      <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={(dashboardData?.applicationsByJob || []).slice(0, 5)}
                          layout="vertical" margin={{ top: 0, right: 10, left: 0, bottom: 0 }}>
                          <XAxis type="number" hide />
                          <YAxis type="category" dataKey="jobTitle" width={80}
                            tick={{ fontSize: 11, fill: APP.textSm }}
                            tickFormatter={v => v.length > 10 ? v.slice(0, 10) + '…' : v}
                            axisLine={false} tickLine={false} />
                          <Tooltip formatter={v => [`${v}`, 'Applications']} contentStyle={tooltipStyle} />
                          <Bar dataKey="applicationCount" fill={APP.primary} barSize={10} radius={[0, 4, 4, 0]} />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  )}
                </div>

                {/* Quick stats */}
                <div style={{ backgroundColor: APP.card, border: `1px solid ${APP.border}` }}
                  className="rounded-2xl p-5">
                  <h3 style={{ color: APP.text }} className="text-sm font-semibold mb-4">Quick stats</h3>
                  <div className="space-y-0 divide-y" style={{ borderColor: APP.borderLight }}>
                    {[
                      { label: 'Applications / job', value: appRate },
                      { label: 'Offer rate', value: `${acceptRate}%` },
                      { label: 'Rejection rate', value: `${rejRate}%` },
                      { label: 'Total jobs posted', value: totalJobs },
                      { label: 'Total applications', value: totalApps },
                      { label: 'Pending decisions', value: pending },
                    ].map(({ label, value }) => (
                      <div key={label} className="flex items-center justify-between py-2.5">
                        <span style={{ color: APP.textSm }} className="text-xs">{label}</span>
                        <span style={{ color: APP.text }} className="text-sm font-bold">{value}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Recent applications */}
                <div style={{ backgroundColor: APP.card, border: `1px solid ${APP.border}` }}
                  className="rounded-2xl p-5">
                  <div className="flex items-center justify-between mb-4">
                    <h3 style={{ color: APP.text }} className="text-sm font-semibold">Recent applications</h3>
                    <button
                      onClick={() => setActiveNav('applications')}
                      style={{ color: APP.primary }}
                      className="inline-flex items-center gap-1 text-xs font-medium hover:underline">
                      View all <ChevronRight size={12} />
                    </button>
                  </div>
                  {!(dashboardData?.recentApplications?.length) ? (
                    <p style={{ color: APP.textXs }} className="text-sm text-center py-6">No applications yet</p>
                  ) : (
                    <div className="divide-y" style={{ borderColor: APP.borderLight }}>
                      {(dashboardData?.recentApplications || []).slice(0, 6).map(app => (
                        <div key={app.id}
                          className="flex items-center gap-3 py-2.5 rounded-lg cursor-pointer hover:bg-slate-50 -mx-2 px-2 transition-colors">
                          <div style={{ backgroundColor: APP.primaryBg, color: APP.primary }}
                            className="w-9 h-9 rounded-full text-sm font-bold flex items-center justify-center flex-shrink-0">
                            {app.candidateName?.charAt(0).toUpperCase()}
                          </div>
                          <div className="flex-1 min-w-0">
                            <p style={{ color: APP.text }} className="text-xs font-medium truncate">{app.candidateName}</p>
                            <p style={{ color: APP.textSm }} className="text-[11px] truncate">{app.jobTitle}</p>
                          </div>
                          <div className="flex flex-col items-end gap-1">
                            <StatusBadge status={app.status} />
                            <span style={{ color: APP.textXs }} className="text-[10px]">
                              {new Date(app.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

              </div>
            )}
          </div>
        </main>
      </div>
    </>
  );
};

export default RecruiterDashboard;